var map = {
	"./autocisterna.png": "a0d5",
	"./gps.png": "2c4b",
	"./gps1.png": "d991",
	"./mezzo0.png": "82b2",
	"./mezzo1.png": "f4ef",
	"./mezzo2.png": "95e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5281";